import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { FaArrowRightLong } from "react-icons/fa6";
import axios from 'axios';
import { BookList } from './bookList';

export const Books = () => {
  const [data, setData] = useState()
  const [selected, setSelected] = useState(0)
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const categoryRefs = useRef([]);

  const categories = ["Civilingeniør", "Medicin", "Pædagog", "Diplomingeniør", "Psykologi", "Erhvervsøkonomi", "Jura", "Folkeskolelærer", "Finansøkonom"]

  useEffect(() => {
    axios.get('/api/books')
      .then(response => {
        setData(response.data.reverse());
      })
      .catch(error => {
        console.log(error);
      });
      
  }, []);

  return (
    <div className="innerContainer mx-auto">
      <div className="py-16 rounded-2xl relative flex flex-col gap-4">
        <div className="flex flex-col gap-y-2 gap-x-4 sm:flex-row justify-between">
        <h2 className="text-lg xl:text-xl font-bold uppercase">Seneste bøger</h2>
          <div className="ml-auto flex items-center gap-2 group cursor-pointer" onClick={() => navigate('/bøger')}>
            <h2 className="text-sm font-semibold text-nowrap">Se flere</h2>
            <FaArrowRightLong className="text-sm group-hover:translate-x-2 transition-[]" />
          </div>
          {/*<div className="w-full text-sm flex gap-2 font-medium overflow-x-scroll no-scrollbar">
            {categories.map((name, index) => {
              return (
                <div ref={(el) => (categoryRefs.current[index] = el)} onClick={() => setSelected(index) & categoryRefs.current[index]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" })} className={"py-1 px-4 rounded-full cursor-pointer transition-[] border border-1 " + (selected === index ? "text-white bg-emerald-600 border-emerald-600" : "hover:border-emerald-500 border-transparent")}>{name}</div>
              )
            })}
          </div>*/}
        </div>
        <BookList data={data} />
      </div>
    </div>
  )
}